<app-semester-select 
    (onClick)="onSemesterSelect($event)"
    [showPreferredBookingInfo]="false"
    [showCompensationGroupSelect]="showCompensationGroupSelect"
    [showInAttendanceOnly]="true">

</app-semester-select>
